<app-header></app-header>
<div class="contenedor_principal">
    <app-menu-alterno></app-menu-alterno>
    <div class="contenidoDivTitulo">
        <div class="div-titulo-seccion">
            <h1 class="h1-titulo-app">Calendario de publicación de estadísticas</h1>
        </div>
        <div class="div-linea-titulo"></div>
    </div>
    <div class="div-lista-filtro" id="publicacion-select">
        <select class="select-lista-filtro" [(ngModel)]='tipoPublicacionSelected' name="tipoPublicacionSelected"
            id="tipoPublicacionSelected" (change)="selectPublicaciones($event)">
            <option value="TODOS">Todas las publicaciones</option>
            <option value="SI" selected>Publicaciones producidas por el Banco de la República</option>
        </select>
    </div>
    <ng-container *ngIf="tipoDispositivo == 'CELULAR'; then viewBotonCelular; else viewBotonEscritorio ">
    </ng-container>
    <ng-template #viewBotonCelular>
        <div class="div-conjunto-botones">
            <div class="div-titulo-fecha">
                <h5 class="texto-titulo-fecha">{{tituloFecha}}</h5>
            </div>
            <div>
                <button class="boton-calendar-azul" id="boton-anterior" value="anterior" (click)="anteriorFecha()">
                    &lt; </button><button class="boton-calendar-azul" id="boton-siguiente" value="siguiente"
                    (click)="seguienteFecha()"> &gt;
                </button>
                <button class="boton-calendar-azul" id="boton-hoy" value="hoy"
                    (click)="seleccionFechaHoy()">Hoy</button>

                <mat-form-field>
                    <input matInput [matDatepicker]="picker" placeholder="Fecha" [(ngModel)]="fechaCalendario"
                        name="fechaCalendario" id="fechaCalendario" (dateInput)="selectFechaCalendario($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </ng-template>
    <ng-template #viewBotonEscritorio>
        <div class="div-conjunto-botones">
            <div><button class="boton-calendar-azul" id="boton-anterior" value="anterior" (click)="anteriorFecha()">
                    &lt; </button><button class="boton-calendar-azul" id="boton-siguiente" value="siguiente"
                    (click)="seguienteFecha()"> &gt;
                </button>
                <button class="boton-calendar-azul" id="boton-hoy" value="hoy"
                    (click)="seleccionFechaHoy()">Hoy</button>

                <mat-form-field>
                    <input matInput [matDatepicker]="picker" placeholder="fecha" [(ngModel)]="fechaCalendario"
                        name="fechaCalendario" id="fechaCalendario" (dateInput)="selectFechaCalendario($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="div-titulo-fecha">
                <h2 class="texto-titulo-fecha">{{tituloFecha}}</h2>
            </div>
            <div style="text-align: right;"><button class="boton-calendar-azul" id="boton-semana" value="Semana"
                    (click)="generaTipoTablaMostrar('SEMANA')">Semana</button>
                <button class="boton-calendar-azul" id="boton-lista" value="Lista"
                    (click)="generaTipoTablaMostrar('LISTA')">Mes</button>
            </div>
        </div>
    </ng-template>
    <div class="div-cuadro-busqueda">
        <input [(ngModel)]="palabraBusqueda" type="text" id="palabraBusqueda" class="input-text"
            placeholder="Buscar publicación" title="Escriba una palabra clave" (keyup.enter)="buscarXPalabraClave()"
            tabindex="0"><input class="input-button" type="image"
            src="/estadisticas-economicas/assets/img/iconos/search.png" (click)="buscarXPalabraClave()" />
    </div>
    <div>
        Las temáticas marcadas con <img src="/estadisticas-economicas/assets/img/catalogo/banrep.svg" width="60" height="20">
        contienen datos producidos por el Banco de la República.
    </div>
    <div><a href="https://dsbb.imf.org/sdds/country/COL/advance-release-calendar-base" target="_blank"
            class="enlace-fmi">
            Si requiere consultar el calendario para el Fondo Monetario Internacional (FMI), ingrese aquí</a>
    </div>
    <div>
        <img *ngIf="cargandoInfo" class="img-load-info" src="/estadisticas-economicas/assets/img/cargando_info.gif" alt="">
        <ng-container *ngIf="tipoTabla == 'LISTA'; then viewTablaLista; else viewTablaSemana ">
        </ng-container>
        <ng-template #viewTablaLista>
            <div class="div-tabla-compromiso-lista">
                <ng-container *ngFor="let diaSemana of listaComMesVista; let idiceSemana=index;">
                    <section id="encabezado-{{diaSemana.id}}">
                        <div
                            class="div-tabla-encabezado encabezado-lista {{diaSemana.estiloHoy}} {{diaSemana.estiloFestivo}}">
                            <div *ngIf="diaSemana.esHoy == 'SI'" class="div-resalta-hoy">
                                <img class="imagen-lista" src="/estadisticas-economicas/assets/img/flecha_derecha_blanco.png" width="30"
                                    height="20" />
                            </div>
                            <div class="encabezado-lista-titulo">{{diaSemana.titulo}}</div>
                        </div>
                        <ng-container *ngFor="let compromiso of diaSemana.listaCompromisos; let idiceCompromiso=index;">
                            <div class="div-tabla-columna">
                                <div class="div-texto-descripcion">
                                    {{compromiso.descripcion}}

                                    <div *ngIf="compromiso.tituloFechaCorte != ''">
                                        <p class="texto-fecha-corte">{{compromiso.tituloFechaCorte}}</p>
                                    </div>

                                </div>
                                <div>
                                    <img *ngIf="compromiso.datoProducidoBanrep == 'SI'" width="50px" height="20px"
                                        src="/estadisticas-economicas/assets/img/catalogo/banrep.svg">
                                </div>
                            </div>
                        </ng-container>
                    </section>
                </ng-container>
            </div>
        </ng-template>
        <ng-template #viewTablaSemana>
            <div class="div-tabla-compromisos-semana">
                <div class="div-tabla-semana-fila">
                    <div *ngFor="let diaSemana of listaComSemanaVista; let idiceSemana=index;"
                        class="div-tabla-semana-columna">
                        <div
                            class="div-tabla-encabezado encabezado-lista {{diaSemana.estiloHoy}} {{diaSemana.estiloFestivo}}">
                            <div *ngIf="diaSemana.esHoy == 'SI'" class="div-resalta-hoy">
                                <img class="imagen-resalta-hoy" src="/estadisticas-economicas/assets/img/flecha_derecha.png" width="30"
                                    height="20" />
                            </div>
                            <div class="encabezado-lista-titulo">{{diaSemana.titulo}}

                                <div *ngIf="diaSemana.estiloFestivo != '' && diaSemana.estiloFestivo.length > 0">
                                    <p class="texto-festivo-col">Festivo en Colombia</p>
                                </div>
                            </div>
                        </div>
                        <div style="text-align: center;"
                            *ngIf="tituloFechaCorte != '' && diaSemana.listaCompromisos.length > 0">
                            <p class="texto-fecha-corte">{{tituloFechaCorte}}</p>
                        </div>
                        <div *ngFor="let compromiso of diaSemana.listaCompromisos; let idiceCompromiso=index;"
                            class="div-tabla-caja">
                            <div class="div-caja-titulo">

                                {{compromiso.descripcion}}

                                <p *ngIf="compromiso.tituloFechaCorte != ''" class="texto-fecha-corte">
                                    {{compromiso.tituloFechaCorte}}</p>
                                <img class="div-img-mona" *ngIf="compromiso.datoProducidoBanrep == 'SI'" width="50px"
                                    height="20px" title="Datos producidos por el Banco de la República"
                                    src="/estadisticas-economicas/assets/img/catalogo/banrep.svg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>